export enum EImpactedOjbectType {
  OBJECT_TYPE = 'OBJECT_TYPE',
  FIELD_VALUE = 'FIELD_VALUE',
  EXT_IDS = 'EXT_IDS',
}
